import { Box } from "@mui/material";
import { formulaMeta } from "./tokens";

// A formula's identity chip: a colored dot + Thai label. Color distinguishes
// formulas only (it does NOT encode which is better).
export default function FormulaChip({
  code,
  size = 13,
}: {
  code: string | null | undefined;
  size?: number;
}) {
  const meta = formulaMeta(code);
  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
      <Box
        sx={{
          width: 9,
          height: 9,
          borderRadius: "50%",
          bgcolor: meta.color,
          flexShrink: 0,
        }}
      />
      <Box component="span" sx={{ fontSize: size, fontWeight: 600, color: "#23252c" }}>
        {meta.label}
      </Box>
    </Box>
  );
}
